import moment from 'moment';

// Same as moment.startOf, but creates a copy of the given object instead.
export default function truncate(d: Date, unit: moment.unitOfTime.StartOf) {
    return moment(d).startOf(unit);
}
